module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datepicker",
    class: {
      'datepicker-range': _vm.range, 'datepicker__clearable': _vm.clearable && _vm.text && !_vm.disabled
    }
  }, [(_vm.type !== 'inline') ? _c('input', {
    class: [_vm.show ? 'focus' : '', _vm.inputClass],
    attrs: {
      "readonly": "",
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "name": _vm.name
    },
    domProps: {
      "value": _vm.text
    }
  }) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "datepicker-close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cls($event)
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "datepicker-anim"
    }
  }, [(_vm.show || _vm.type === 'inline') ? _c('div', {
    staticClass: "datepicker-popup",
    class: [_vm.popupClass, {
      'datepicker-inline': _vm.type === 'inline'
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [(_vm.range) ? [_c('vue-datepicker-local-calendar', {
    attrs: {
      "left": true
    },
    model: {
      value: (_vm.dates[0]),
      callback: function($$v) {
        _vm.$set(_vm.dates, 0, $$v)
      },
      expression: "dates[0]"
    }
  }), _vm._v(" "), _c('vue-datepicker-local-calendar', {
    attrs: {
      "right": true
    },
    model: {
      value: (_vm.dates[1]),
      callback: function($$v) {
        _vm.$set(_vm.dates, 1, $$v)
      },
      expression: "dates[1]"
    }
  })] : [_c('vue-datepicker-local-calendar', {
    model: {
      value: (_vm.dates[0]),
      callback: function($$v) {
        _vm.$set(_vm.dates, 0, $$v)
      },
      expression: "dates[0]"
    }
  })], _vm._v(" "), (_vm.showButtons) ? _c('div', {
    staticClass: "datepicker__buttons"
  }, [_c('button', {
    staticClass: "datepicker__button-cancel",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(this.local.cancelTip))]), _vm._v(" "), _c('button', {
    staticClass: "datepicker__button-select",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.submit($event)
      }
    }
  }, [_vm._v(_vm._s(this.local.submitTip))])]) : _vm._e()], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05557de5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-datepicker-local/src/VueDatepickerLocal.vue
// module id = 1999
// module chunks = 1